import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./qsr_automations_mode.js";
//#region src/qsr_automations_mode_helper.ts
var qsr_automations_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(mode) {
	switch (mode) {
		case "sending-and-webhooks": return "Sending";
		case "pos-webhooks": return "POS Webhooks";
	}
}
//#endregion
export { name, qsr_automations_mode_helper_exports };

//# sourceMappingURL=qsr_automations_mode_helper.js.map